<template>
  <div>
    <div class="block">
      <!-- 會議主旨 -->
      <label class="form-item pt-5 d-flex">
        <div class="w-240px mr-5">
          <h4>會議主旨</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="shareholderMeeting.title"
            placeholder="請輸入會議主旨"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 設定活動時間 -->
      <div class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>設定活動時間</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="shareholderMeeting.event_date"
                placeholder="請選擇日期"
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="shareholderMeeting.event_date"
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </div>
      </div>
    </div>
    <div class="page-divider my-5"></div>
    <!-- downloads -->
    <div class="d-flex">
      <h3 class="w-300px mr-5">Downloads</h3>
      <div class="pa-5 block flex-grow-1 flex-basis-0">
        <div>
          <h3 class="mb-5">Downloads</h3>
          <div class="h4 mb-5">
            顯示於Shareholder Meeting頁，若要新增數量，請點擊下方 [添加] 按鈕
          </div>

          <!-- items -->
          <PageCollapse v-for="(item, i) in shareholderMeeting.downloads" :key="i">
            <template v-slot:head>
              <h3 class="mr-auto">File {{ i + 1 }}</h3>
            </template>
            <template v-slot:actions>
              <div class="ml-auto">
                <button class="btn square mr-10px" @click="deleteItem(i)">
                  <v-icon class="ink-02-medium--text">delete</v-icon>
                </button>
                <button class="btn square mr-10px" @click="downItem(item, i)">
                  <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
                </button>
                <button class="btn square" @click="upItem(item, i)">
                  <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
                </button>
              </div>
            </template>
            <template v-slot:body>
              <!-- 顯示名稱 -->
              <label class="form-item d-flex pb-3">
                <h4 class="w-180px mt-5">顯示名稱</h4>
                <div class="flex-grow-1 mt-3">
                  <div class="form-input-group">
                    <input type="text" v-model="item.title" />
                  </div>
                </div>
              </label>
              <!-- 檔案 -->
              <div class="d-flex px-5 pt-5 mb-8">
                <div class="w-180px">
                  <h4 class="mb-10px">檔案</h4>
                  <div class="h5 ink-02-medium--text">
                    格式：.pdf <br />
                    檔案大小限制：≤ 10 MB
                  </div>
                </div>
                <div class="d-flex justify-end flex-grow-1">
                  <FileUploader
                    v-model="item.file"
                    dir="ir"></FileUploader>
                </div>
              </div>
            </template>
          </PageCollapse>

          <!-- add team sponsorship -->
          <div class="mt-5">
            <button
              class="btn btn-outlined w-100 justify-start"
              @click="addItem"
            >
              <v-icon class="primary--text mr-2">add_circle</v-icon>
              <span>添加</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PageCollapse from '@/components/PageCollapse.vue';
import FileUploader from '@/components/FileUploader.vue';

export default {
  components: {
    PageCollapse,
    FileUploader,
  },
  data: () => ({
    dateMenu: false,
  }),
  computed: {
    ...mapState('shareholderMeeting', ['shareholderMeeting']),
  },
  methods: {
    addItem() {
      const template = {
        title: '',
        file: '',
      };
      this.shareholderMeeting.downloads.push(template);
    },
    deleteItem(index) {
      this.shareholderMeeting.downloads.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.shareholderMeeting.downloads.length - 1) {
        this.shareholderMeeting.downloads.splice(i, 1);
        this.shareholderMeeting.downloads.unshift(item);
        return;
      }
      // item become next index
      this.shareholderMeeting.downloads.splice(i, 1);
      this.shareholderMeeting.downloads.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.shareholderMeeting.downloads.splice(i, 1);
        this.shareholderMeeting.downloads.push(item);
        return;
      }
      // item become previous index
      this.shareholderMeeting.downloads.splice(i, 1);
      this.shareholderMeeting.downloads.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
